import React, { useState } from 'react'
import { AlertTriangle, X } from 'lucide-react'

export function ConfirmModal({ isOpen, onClose, onConfirm, title, message, confirmText = 'Delete', type = 'danger', showReason = false }) {
  const [reason, setReason] = useState('')
  if (!isOpen) return null

  const isDanger = type === 'danger'

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()} style={{ zIndex: 2000 }}>
      <div className="modal" style={{ maxWidth: 400, animation: 'modal-pop 0.2s ease-out' }}>
        <div className="modal-header" style={{ borderBottom: 'none', paddingBottom: 0 }}>
          <div style={{ 
            width: 40, 
            height: 40, 
            borderRadius: 10, 
            background: isDanger ? 'var(--danger-glow)' : 'var(--accent-glow)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 8
          }}>
            <AlertTriangle size={20} color={isDanger ? 'var(--danger)' : 'var(--accent)'} />
          </div>
          <button className="btn btn-ghost btn-sm" style={{ padding: 6, position: 'absolute', right: 16, top: 16 }} onClick={onClose}>
            <X size={16} />
          </button>
        </div>
        <div className="modal-body" style={{ textAlign: 'center', paddingTop: 0 }}>
          <h2 style={{ fontSize: '1.25rem', marginBottom: 8 }}>{title}</h2>
          <p style={{ color: 'var(--text-secondary)', fontSize: '0.9375rem', lineHeight: 1.5, marginBottom: showReason ? 16 : 0 }}>{message}</p>
          
          {showReason && (
            <div className="form-group" style={{ textAlign: 'left', marginTop: 12 }}>
              <label className="form-label" style={{ fontSize: '0.75rem' }}>Justification / Reason (Required)</label>
              <textarea 
                className="form-input" 
                style={{ fontSize: '0.8125rem', minHeight: 80 }}
                placeholder="Why is this being deleted?"
                value={reason}
                onChange={e => setReason(e.target.value)}
              />
            </div>
          )}
        </div>
        <div className="modal-footer" style={{ borderTop: 'none', gap: 12 }}>
          <button className="btn btn-secondary" style={{ flex: 1 }} onClick={onClose}>Cancel</button>
          <button 
            className={`btn ${isDanger ? 'btn-danger' : 'btn-primary'}`} 
            style={{ flex: 1 }} 
            disabled={showReason && !reason.trim()}
            onClick={() => {
              onConfirm(reason)
              onClose()
              setReason('')
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  )
}
